module.exports = __webpack_public_path__ + "img/logo-2.18cfbae5.png";